import { useMemo } from 'react';
import { getLifestyleCategoryTranslationKey } from '@pkgs/components/utils/translationKeyUtils';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { defaultLifestyleCategoryState } from '@pkgs/components/hooks/stores/search/slices/lifestyleCategorySlice';
import { getEntries } from '@ev-tech/search-modules-api';

import { LifestyleFilterDropdown } from './LifestyleFilterDropdown';
import { LifestyleFilter } from './LifestyleFilter';

export const LifestyleFilterButton = () => {
  const { t } = useAppContext();

  const lifestyleCategories = useSearchStore((state) => state.lifestyleCategories);

  const activeCategories = getEntries(lifestyleCategories).filter(([, value]) => value);

  const buttonLabel = useMemo(() => {
    if (activeCategories.length === 0) return t('search.searchbar.lifestyle');

    // Take key from first active lifestyle category
    const [key] = activeCategories[0]!;

    const lifestyleCategoryTranslationKey = getLifestyleCategoryTranslationKey(key);
    if (lifestyleCategoryTranslationKey) {
      return t(lifestyleCategoryTranslationKey);
    }
    return key;
  }, [activeCategories, t]);

  return (
    <LifestyleFilterDropdown
      label={buttonLabel}
      count={activeCategories.length > 1 ? activeCategories.length - 1 : undefined}
      isActive={activeCategories.length > 0}
      defaultState={defaultLifestyleCategoryState}
      data-testid="search-components_lifestyle-filter-button"
    >
      <LifestyleFilter />
    </LifestyleFilterDropdown>
  );
};
